export default __webpack_public_path__ + "static/Tek_Shield-70eee383600f293433cd887ce41bfd30.png";